export { default as ErrorLoadingData } from "./ErrorLoadingData"
export type { IErrorLoadingDataProps } from "./ErrorLoadingData"
